import * as R from 'ramda';

import * as SearchFilters from 'ha/types/SearchFilters';
import { KindsForSavedSearch } from '../constants';

export default (categories: SearchFilters.TypeFilterValue): string[] => {
  const list =
    categories.length === 0
      ? R.values(KindsForSavedSearch)
      : categories.map(category => KindsForSavedSearch[category]);

  return R.uniq(R.flatten<string>(list));
};
